module.exports = __webpack_public_path__ + "static/assets/aeafc408498898ccbf72a72fb38a80f1.svg";